import React from "react";
import { useRoutes } from "react-router-dom";
import { Layout } from "antd";
import { ICustomRouterConfig } from "@/routers";
const { Content } = Layout;
type LayoutAuthorityProps = {
  routes: ICustomRouterConfig[];
};

const LayoutNoAuthority = (props: LayoutAuthorityProps) => {
  const { routes } = props;
  return (
    <Layout className="layout-body">
      <Content
        className="content"
        style={{
          padding: "16px 0 0 0",
        }}
      >
        {useRoutes(routes)}
      </Content>
    </Layout>
  );
};

export default LayoutNoAuthority;
